import * as React from 'react';

import moment from 'moment';

import { IListingBasic } from '../../declarations';

import './ClosingDateListingCardStyle.less';

export interface IClosingDateListingCardProps {
  closeOfEscrowDate: string;
  listing: IListingBasic;
}

export default class ClosingDateListingCard extends React.Component<IClosingDateListingCardProps> {
  public render() {
    const { closeOfEscrowDate, listing } = this.props;

    const firstListingPhoto = listing.listing_photos[0];
    const photoUrl = firstListingPhoto
      ? firstListingPhoto.thumbnail_urls._760x480
      : 'https://images.opendoor.com/source/s3/imgdrop-production/hvr-empty-home.png?service=consumer';

    const listingAddressString =
      listing.address.street1 + (listing.address.city ? `, ${listing.address.city}` : '');

    const closingDateString = moment(closeOfEscrowDate).format('MMMM D, YYYY');
    return (
      <div className="closing-date-listing-card">
        <div
          className="listing-photo"
          style={{
            backgroundImage: `url(${photoUrl})`,
          }}
        />
        <div className="listing-address">{listingAddressString}</div>
        <div className="closing-date">Closing Date {closingDateString}</div>
      </div>
    );
  }
}
